import { Loading, CustomTooltip } from "../../components"
import React from 'react';
import Wrapper from '../../assets/wrappers/DiagramsMonthlyProgression';
import { Link } from "react-router-dom";
import { BsPlusCircle } from 'react-icons/bs'
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import calculations from '../../utils/calculations';
import { useAppContext } from "../../context/appContext";
import { useEffect } from "react";
import { PageBtnContainer } from "../../components";

const DiagramsMonthlyProgression = () => {
    const { isLoading, getInformationItems,
        informationItems,
        yearToDisplay, } = useAppContext()

    useEffect(() => {
        getInformationItems();
    }, [yearToDisplay])

    var dataToDisplay = []

    if (informationItems[yearToDisplay]) {
        const informationItemsToDisplay = calculations.filterItemsOfYear(informationItems, yearToDisplay)

        if (informationItemsToDisplay) {
            Object.values(informationItemsToDisplay).forEach((item, index) => {
                if (index > 0) {
                    var result = calculations.calculateConsumption(informationItemsToDisplay[index],
                        informationItemsToDisplay[index - 1] ? informationItemsToDisplay[index - 1] : null)
                    result['month'] = informationItemsToDisplay[index].month
                    dataToDisplay = dataToDisplay.concat([result])
                }
            })
        }
    }

    return (
        <Wrapper>
            <h3>Monatsverlauf</h3>
            <div className="header">
                {Object.keys(informationItems).length === 0 ? <h5>Keine Einträge gefunden...</h5> :
                    <h5>{dataToDisplay.length} {dataToDisplay.length > 1 ? "Monate" : "Monat"} für {yearToDisplay} gefunden</h5>
                }
                <Link to="/add-informationItem" type="button" className="btn"><BsPlusCircle />Eintrag hinzufügen</Link>
            </div>

            {Object.keys(informationItems).length === 0 ? <></> : <PageBtnContainer />}

            {
                isLoading ? <Loading center /> :
                    <div className='diagramsContainer'>

                        <div className='diagramAndHeading'>
                            <h4>Stromverbrauch von {yearToDisplay} in kWh</h4>
                            <div className='diagram'>
                                <ResponsiveContainer>
                                    <LineChart
                                        data={dataToDisplay}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis domain={[0, 500]} allowDataOverflow={true} />
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />
                                        <Line type="monotone" name="Stromverbrauch" dataKey="consumptionElectricity" stroke="red" />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                        <div className='diagramAndHeading'>
                            <h4>Heizungsverbrauch von {yearToDisplay} in kWh</h4>
                            <div className='diagram'>
                                <ResponsiveContainer>
                                    <LineChart
                                        data={dataToDisplay}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis domain={[0, 4000]} allowDataOverflow={true} />
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />
                                        <Line type="monotone" name="Heizungsverbrauch" dataKey="consumptionHeating" stroke="orange" />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                        <div className='diagramAndHeading'>
                            <h4>PV-Ertrag von {yearToDisplay} in kWh</h4>
                            <div className='diagram'>
                                <ResponsiveContainer>
                                    <LineChart
                                        data={dataToDisplay}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis domain={[0, 1300]} allowDataOverflow={true} />
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />
                                        <Line type="monotone" name="PV-Ertrag" dataKey="gainPhotovoltaic" stroke="green" />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                        <div className='diagramAndHeading'>
                            <h4>Wasserverbrauch von {yearToDisplay} in m³</h4>
                            <div className='diagram'>
                                <ResponsiveContainer>
                                    <LineChart
                                        data={dataToDisplay}
                                        margin={{
                                            top: 5,
                                            right: 30,
                                            left: 20,
                                            bottom: 5
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="month" />
                                        <YAxis domain={[0, 13]} allowDataOverflow={true} />
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />

                                        <Line type="monotone" name='Wasserverbrauch' dataKey="consumptionWater" stroke="blue" />
                                    </LineChart>
                                </ResponsiveContainer>
                            </div>
                        </div>

                    </div>
            }
        </Wrapper>
    )
}

export default DiagramsMonthlyProgression